import Link from "next/link";
import { useRouter } from "next/navigation";
import React, { useEffect, useState } from "react";
import { extractFormData } from "@/utils/function";
import { SignUpApi } from "@/api/auth";

import { ToastContainer, toast } from "react-toastify";

import sal from "sal.js";

import { userStore } from "@/store/user";
import { passwordRegex, phoneRegex } from "@/data";

const SignUp = () => {
  const { setUser } = userStore();
  const router = useRouter();
  const [loading, setLoading] = useState(false);

  const [formErrors, setFormErrors] = useState({
    firstName: false,
    lastName: false,
    phoneNumber: false,
    email: false,
    password: false,
    confirmPassword: false,
  });

  useEffect(() => {
    sal();
    const cards = document.querySelectorAll(".bg-flashlight");

    cards.forEach((bgflashlight) => {
      bgflashlight.onmousemove = function (e) {
        let x = e.pageX - bgflashlight.offsetLeft;
        let y = e.pageY - bgflashlight.offsetTop;

        bgflashlight.style.setProperty("--x", x + "px");
        bgflashlight.style.setProperty("--y", y + "px");
      };
    });
  }, []);

  const handleInputChange = (e) => {
    const { name } = e.target;
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      [name]: false,
    }));
  };

  const handleSignUp = async (e) => {
    e.preventDefault();
    setLoading(true);

    const form = e.target;
    const { firstName, lastName, phoneNumber, email, password, confirmPassword } = extractFormData(form);

    if (!firstName || !lastName || !phoneNumber || !email || !password || !confirmPassword) {
      setFormErrors({
        firstName: !firstName,
        lastName: !lastName,
        phoneNumber: !phoneNumber || !phoneRegex.test(phoneNumber),
        email: !email,
        password: !password,
        confirmPassword: !confirmPassword,
      });
      setLoading(false);
      return;
    }

    if (!passwordRegex.test(password)) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        password: "Min 8 chars, 1 uppercase, 1 number, 1 symbol",
      }));
      setLoading(false);
      return;
    }


    if (password !== confirmPassword) {
      setFormErrors({
        ...formErrors,
        confirmPassword: true,
      });
      setLoading(false);
      return;
    }

    try {
      const response = await SignUpApi({
        firstName,
        lastName,
        phoneNumber,
        email,
        password,
      });
      if (response?.status !== 200) {
        toast.error(response?.data?.message || "Signup failed! Please try again.");
        setLoading(false);
        return;
      }

      const { _id, token } = response?.data;
      if (_id) localStorage.setItem("userId", _id)
      toast.success("Signup successful! Redirecting...");
      setTimeout(() => {
        router.push("/auth/choose-plan");
      }, 500);
    } catch (error) {
      const errorCode = error?.response?.data?.message?.split(' ')[0];
      if (errorCode === 'E11000') {
        toast.error("User already exist!");
      } else {
        toast.error(error?.response?.data?.message);
      }
    } finally {
      setLoading(false);
    }
  };


  return (
    <>
      <ToastContainer />

      <div
        className="signup-area rainbow-section-gapTop-big"
        data-black-overlay="2"
      >
        <div className="sign-up-wrapper rainbow-section-gap">
          <div className="sign-up-box bg-flashlight">
            <div className="signup-box-top top-flashlight light-xl">
            </div>
            <div className="signup-box-bottom">
              <div className="signup-box-content">
                <h4 className="title">Welcome Back!</h4>

                <form method="POST" onSubmit={handleSignUp}>
                  <div
                    className="flex-row gap-4"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      alignContent: "center",
                      justifyContent: "center",
                    }}
                  >

                    <div className="input-section">
                      <div className=" icon">
                        <i className="feather-user"></i>
                      </div>
                      <input
                        type="text"
                        name="firstName"
                        placeholder="First Name"
                        onChange={handleInputChange}
                      />
                      {formErrors?.firstName && (
                        <span className="error">First Name is required</span>
                      )}
                    </div>

                    <div className="input-section ">
                      <div className=" icon">
                        <i className="feather-user"></i>
                      </div>
                      <input
                        type="text"
                        name="lastName"
                        placeholder="Last Name"
                        onChange={handleInputChange}
                      />
                      {formErrors?.lastName && (
                        <span className="error">Last Name is required</span>
                      )}
                    </div>
                  </div>

                  <div className="input-section">
                    <div className=" icon">
                      <i className="feather-phone"></i>
                    </div>
                    <input
                      type="text"
                      name="phoneNumber"
                      placeholder="Phone number"
                      onChange={(e) => {
                        const value = e?.target?.value?.replace(/[^0-9]/g, "");
                        e.target.value = value;
                        handleInputChange(e);
                      }}
                    />
                    {formErrors?.phoneNumber && (
                      <span className="error">
                        {document.querySelector('input[name="phoneNumber"]')?.value?.length === 0
                          ? "Phone Number is required"
                          : "Must be 10-15 digits"}
                      </span>
                    )}

                  </div>

                  <div className="input-section mail-section">
                    <div className="icon">
                      <i className="feather-mail"></i>
                    </div>
                    <input
                      type="email"
                      name="email"
                      placeholder="Enter email address"
                      onChange={handleInputChange}
                    />
                    {formErrors?.email && (
                      <span className="error">Email is required</span>
                    )}
                  </div>
                  <div className="input-section password-section">
                    <div className="icon">
                      <i className="feather-lock"></i>
                    </div>
                    <input
                      type="password"
                      name="password"
                      placeholder="Create Password"
                      onChange={handleInputChange}
                    />
                    {formErrors?.password === true ?
                      <span className="error">Password is required</span>
                      : <span className="error">{formErrors?.password}</span>
                    }
                  </div>
                  <div className="input-section password-section">
                    <div className="icon">
                      <i className="feather-lock"></i>
                    </div>
                    <input
                      type="password"
                      name="confirmPassword"
                      placeholder="Confirm Password"
                      onChange={handleInputChange}
                    />
                    {formErrors?.confirmPassword && (
                      <span className="error">Passwords do not match</span>
                    )}
                  </div>
                  <button
                    type="submit"
                    className="btn-default"
                    disabled={loading}
                  >
                    {loading ? <div className="spinner"></div> : "Sign Up"}
                  </button>
                </form>
              </div>
              <div className="signup-box-footer">
                <div className="bottom-text">
                  Don&apos;t have an account?
                  <Link className="btn-read-more ps-2" href="/auth/signin">
                    <span>Sign In</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignUp;
